import { Message } from './components/Message';
import { ChatMessagesLoading } from './components/ChatMessagesLoading';

interface ChatMessage {
  id: string;
  content: string;
  created: string;
  sender: string;
  userData?: { given_name?: string; family_name?: string; img?: string };
}

interface ProjectChatMessagesProps {
  messages: ChatMessage[] | null;
  isVisible: boolean;
  projectId: string;
  uid: string | null;
  userRole: string | null;
  updateModalOpen: (type: string, params?: Record<string, unknown>) => void;
}

export function ProjectChatMessages({
  messages,
  isVisible,
  projectId,
  uid,
  userRole,
  updateModalOpen,
}: ProjectChatMessagesProps) {
  return (
    <ul className={isVisible ? '' : 'hidden'}>
      {messages ? (
        messages.map((msg) => (
          <Message
            key={msg.created}
            firstName={msg.userData?.given_name}
            lastName={msg.userData?.family_name}
            created={msg.created}
            content={msg.content}
            image={{ task: false, imageUrl: msg.userData?.img }}
            isAReply={false}
            messageId={msg.id}
            projectId={projectId}
            isRemovable={
              (userRole === 'admin' || uid === msg.sender) && userRole !== 'guest' && !!msg.id
            }
            updateModalOpen={updateModalOpen}
          />
        ))
      ) : (
        <ChatMessagesLoading amount={5} />
      )}
    </ul>
  );
}
